import { type FC, useContext } from "react";
import { DragDropEditorContext, type DragDropSettingsProps } from "../../../Forms/DragDrop/DragDropTypes";
import { hasColumnsValue, ReorderableTableSettings } from "../../../Forms/DragDrop/ReorderableTableSettings";

const COLUMN_DEFINITIONS = {
    tax  : "Tax",
    total: "Total",
};

export const ReceiptTaxTableSettings: FC<DragDropSettingsProps> = ({
    id,
    value,
}) => {
    const { manager } = useContext(DragDropEditorContext);

    const columns = hasColumnsValue(value) ? value.columns : [];

    return (
        <ReorderableTableSettings
            renameable
            columns={COLUMN_DEFINITIONS}
            value={columns}
            onChange={columns => {
                manager.updateComponent(id, {
                    ...(hasColumnsValue(value) ? value : {}),
                    columns,
                });
            }}
        />
    );
};
